<div class="pdf-wrapper">
  <div class="pdf-container" [class.position-setting-mode]="!!floatingFieldSubscriber" [class.d-none]="renderOnIframe" #pdfContainer></div>
  <app-floating-fields
    [pdfContainer]="pdfContainer"
    [enableEdit]="enableEditFloatingFields"
    [scale]="floatingFieldsScale"
    [pagesCount]="pdf?.numPages"
    [qualified]="qualified"
    [isNewSignatureStyle]="isNewSignatureStyle"
    [documentWhitelabel]="documentWhitelabel"
    [documentLocale]="document?.locale"
    [class.d-none]="renderOnIframe"
    (selectChange)="selectedFieldChange.emit($event)"
    [isDocumentWhitelabelLoaded]="isDocumentWhitelabelLoaded"
    #floatingFields
  >
  </app-floating-fields>

  @if (documentFooter) {
    <app-footer-preview
      [pagesCount]="pdf?.numPages"
      [loadedPages]="loadedPages"
      [pdfContainer]="pdfContainer"
      [class.d-none]="renderOnIframe"
      [documentFooter]="documentFooter"
      [documentFooterType]="documentFooterType"
      [qualified]="qualified"
      [document]="document"
      [documentWhitelabel]="documentWhitelabel"
      [isDocumentWhitelabelLoaded]="isDocumentWhitelabelLoaded"
    >
    </app-footer-preview>
  }
  @if (safePdfUrl && hasIframeLoad) {
    <iframe [src]="safePdfUrl" frameborder="0" width="100%" height="1300px" [class.d-none]="!renderOnIframe"></iframe>
  }
</div>
<app-document-loader class="mt-3" [class.d-none]="renderOnIframe || pdf?.numPages === pdfContainer.childElementCount"></app-document-loader>
